import { z } from 'zod';

/**
 * The id a hand-typed Cash or Investments account row carries (crossmarc/steward-app#2185), and
 * that a statement uploaded into the row names back.
 *
 * Minted by the browser when the row is added with "Enter by hand" (a row loaded without a valid
 * one is given one), so the row can be told apart from its neighbours after one is removed or the
 * list is reloaded. 16 to 32 letters and digits: wide enough for a random 128-bit hex string, and
 * nothing that could shape a path, a key or markup.
 *
 * It is a claim about the client's own draft and is trusted for nothing beyond that: it picks
 * which of the same person's rows a statement is shown under. **It is never content.** A row
 * holding nothing but its id is a blank row: `isEmptyValue` (`intakeSchema.ts`) skips this key, so
 * such a row is not an answer, does not start a section, and cannot pass the not-empty check. A
 * statement whose id matches no row with content is shown to an advisor as an unattached upload.
 */
export const INTAKE_ROW_ID_KEY = 'rowId';

export const INTAKE_ROW_ID_PATTERN = /^[A-Za-z0-9]{16,32}$/;

export const IntakeRowIdSchema = z.string().regex(INTAKE_ROW_ID_PATTERN);
